import { RouterProvider, createRouter } from "@tanstack/react-router";
import { ErrorBoundary } from "@/components/layout/ErrorBoundary";
import { queryClient } from "@/contexts/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "@/components/ui/Toast";
import { TooltipProvider } from "@/components/ui/Tooltip";
import { routeTree } from "./routeTree.gen";

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof createRouter>;
  }
}

const router = createRouter({
  routeTree,
  Wrap: ({ children }) => (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider delayDuration={200}>
          {children}
          <ToastContainer />
        </TooltipProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  ),
});

export function Router() {
  return <RouterProvider router={router} />;
}
